import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "./client";

export const useLatestCurrencyConversion = () => {
  return useQuery({
    queryKey: ["currency", "latest"],
    queryFn: async () => {
      const res = await client.currency.latest.$get();
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
